import Immutable from 'seamless-immutable';
import {
  ATTACHMENT_CREATE_API_FULFILLED,
  ATTACHMENT_DELETE_API_FULFILLED,
  ATTACHMENTS_FETCH_API_FULFILLED,
  ATTACHMENTS_FETCH_API_REJECTED,
  ATTACHMENTS_FETCH_START,
  DELETE_ATTACHMENT
} from '../actions';

const initialState = Immutable.from({
  list: [],
  issueId: '',
  isLoading: false,
  totalResults: Infinity
});

const attachUploadedFileIdToAttachments = (state, payload) => {
  const prevAttachmentIdToFileId = state.list.reduce((map, attachment) => {
    if (attachment.fileId) {
      map[attachment.id] = attachment.fileId;
    }
    return map;
  }, {});
  return payload.map(attachment => ({
    ...attachment,
    fileId: prevAttachmentIdToFileId[attachment.id]
  }));
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ATTACHMENTS_FETCH_START:
      if (state.issueId !== action.payload) {
        return state.merge({
          issueId: action.payload,
          list: [],
          isLoading: true
        });
      }
      return state.merge({
        isLoading: true
      });
    case ATTACHMENTS_FETCH_API_FULFILLED: {
      if (action.payload.length) {
        const list = attachUploadedFileIdToAttachments(state, action.payload);
        return state.merge({
          // Update all new attachments we just got from BE with `fileId` field from the current attachment list (if exists).
          // We need to continue using `fileId` key for attachment animations.
          list: action.meta.offset === 0 ? list : [...state.list, ...list],
          issueId: action.meta.id,
          isLoading: false,
          totalResults: action.meta.totalResults
        });
      } else {
        return state.merge({
          isLoading: false,
          issueId: action.meta.id,
          totalResults: action.meta.totalResults
        });
      }
    }
    case ATTACHMENTS_FETCH_API_REJECTED:
      return state.merge({isLoading: false});
    case ATTACHMENT_CREATE_API_FULFILLED: {
      if (state.issueId === action.payload.issueId) {
        const list = [
          {
            ...action.payload,
            fileId: action.meta.fileId
          },
          ...state.list
        ];
        return state.merge({list});
      }
      return state;
    }
    case DELETE_ATTACHMENT: {
      const list = state.list.map(attachment =>
        attachment.id === action.payload.attachmentId ? {...attachment, isDeleting: true} : attachment
      );
      return state.merge({list});
    }
    case ATTACHMENT_DELETE_API_FULFILLED: {
      const list = state.list.filter(file => file.id !== action.meta.attachmentId);
      return state.merge({list});
    }
    default:
      return state;
  }
};
